<p>change-project-checkin-start-date works!</p>
